import { Routes } from '@angular/router';
import { RoutePaths } from './core/constants/route-paths';
import { LoginFormComponent } from './components/login/login-form/login-form.component';
import { ForgotPasswordComponent } from './components/login/forgot-password/forgot-password.component';
import { ForgotPasswordRegenerationComponent } from './components/login/forgot-password-regeneration/forgot-password-regeneration.component';
import { RegistrationFormSimpleComponent } from './components/login/registration/registration-form-simple/registration-form-simple.component';
import { HomeComponent } from './components/home/home.component';
import { CookiesPageComponent } from './components/cookies/cookies-page/cookies-page.component';
import { authGuard } from './core/guards/auth.guard';
import { ContentEditorComponent } from './components/my-content/content-editor/content-editor.component';
import { ContentSearchComponent } from './components/my-content/content-search/content-search.component';
import { ManagementsComponent } from './components/my-managements/managements/managements.component';
import { ContentPowerbiComponent } from './components/contents/content-powerbi/content-powerbi.component';
import { PolicyPageComponent } from './components/cookies/policy-page/policy-page.component';

export const routes: Routes = [
    {
        path: `${RoutePaths.login}`,
        component: LoginFormComponent,
    },
    {
        path: `${RoutePaths.login}/:close`,
        component: LoginFormComponent,
    },
    {
        path: `${RoutePaths.registration}`,
        component: RegistrationFormSimpleComponent,
    },
    {
        path: `${RoutePaths.changePassword}`,
        component: ForgotPasswordComponent,
    },
    {
        path: `${RoutePaths.updatePassword}`,
        component: ForgotPasswordRegenerationComponent,
    },
    {
        path: `${RoutePaths.cookiesPage}`,
        component: CookiesPageComponent,
    },
    {
        path: `${RoutePaths.policyPage}`,
        component: PolicyPageComponent,
    },
    {
        path: `${RoutePaths.home}`,
        component: HomeComponent,
        canActivate: [authGuard],
    },
    {
        path: `${RoutePaths.contentManag}`,
        component: ContentSearchComponent,
        canActivate: [authGuard],
    },
    {
        path: `${RoutePaths.contentEditor}/:id`,
        component: ContentEditorComponent,
        canActivate: [authGuard],
    },
    {
        path: `${RoutePaths.managements}`,
        component: ManagementsComponent,
        canActivate: [authGuard],
    },
    {
        path: `${RoutePaths.contentPowerBI}/:content`,
        component: ContentPowerbiComponent,
        canActivate: [authGuard],
    },
    {
        path: `${RoutePaths.empty}`,
        redirectTo: `${RoutePaths.login}`,
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: `${RoutePaths.login}`
    },
];
